module.exports = __webpack_public_path__ + "img/5.214d88e9.jpg";